import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Shield, Crosshair, Wrench } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function SafesAccessories() {
  useDocumentMeta('Gun Safes, Cases & Shooting Accessories | Kjergaard Sports', 'Find gun safes, cases, holsters, cleaning supplies, magazines, targets, and shooting accessories at Kjergaard Sports in Lake Benton, Minnesota.');
  const categories = ['Safes', 'Cases', 'Holsters', 'Cleaning supplies', 'Magazines', 'Rests', 'Targets', 'Maintenance items', 'Shooting accessories'];
  return <div data-id="element-707">
      <PageHero title="Gun Safes, Cases & Shooting Accessories" image="https://cdn.magicpatterns.com/uploads/esrRsJE1XbS5zcQi7PgR9E/safes-display.jpg" alt="Gun safes and secure storage at Kjergaard Sports" data-id="element-708" />

      <section className="py-20 bg-brand-offwhite" data-id="element-709">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-710">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-711">
            <div data-id="element-712">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-713">
                Secure Storage & Essential Gear
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-714">
                Protecting your investment and maintaining your equipment is
                just as important as the firearm itself. Kjergaard Sports
                carries a robust selection of heavy-duty gun safes, secure
                transport cases, and everyday maintenance accessories.
              </p>
              <p className="text-lg text-brand-charcoal/80 mb-8 leading-relaxed" data-id="element-715">
                Visit the store to compare options in person. We can help you
                evaluate safe sizes, fire ratings, and security features to find
                the right fit for your home.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-716">
                <h3 className="font-serif text-xl mb-4" data-id="element-717">
                  Our Accessory Selection Includes:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-718">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-719">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-720" />
                      <span className="text-brand-charcoal/90" data-id="element-721">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div data-id="element-722">
              <img src="https://cdn.magicpatterns.com/uploads/jwChz1kho8pae8NFhrqrQH/accessories-wall.jpg" alt="Shooting accessories at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-723" />
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-724">
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-725">
              <Shield className="w-10 h-10 text-brand-hunter mb-4" data-id="element-726" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-727">
                Secure Storage
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-728">
                Heavy-duty gun safes, lockboxes, and secure transport cases to
                keep your firearms protected at home and on the road.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-729">
              <Crosshair className="w-10 h-10 text-brand-hunter mb-4" data-id="element-730" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-731">
                Shooting Accessories
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-732">
                Holsters, magazines, slings, rests, targets, and the practical
                gear you need for a successful day at the range or in the field.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-733">
              <Wrench className="w-10 h-10 text-brand-hunter mb-4" data-id="element-734" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-735">
                Cleaning & Maintenance
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-736">
                Solvents, oils, brushes, rods, and complete cleaning kits to
                keep your equipment functioning reliably.
              </p>
            </div>
          </div>

          <div className="relative rounded-sm overflow-hidden shadow-lg" data-id="element-737">
            <img src="https://cdn.magicpatterns.com/uploads/4W49omroAHfAdaTefJNmcK/targets-shooting-supplies.jpg" alt="Targets and shooting supplies at Kjergaard Sports" className="w-full h-[300px] object-cover" data-id="element-738" />
            <div className="absolute inset-0 bg-brand-charcoal/60 flex items-center justify-center p-8" data-id="element-739">
              <h3 className="text-3xl md:text-4xl font-serif text-brand-offwhite text-center max-w-2xl drop-shadow-md" data-id="element-740">
                Everything You Need for the Range
              </h3>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-741" />
    </div>;
}